import * as React from 'react';
import { FontIcon, IContextualMenuListProps } from '@fluentui/react';
import {
    IGroupedComboBoxButtonIconProps,
    IGroupedComboBoxButtonLabelProps,
} from '../GroupedComboBox/GroupedComboBox.types';
import { OnRenderIconResult, RefreshSubmenuCallback, SubmenuContext } from 'grouped-combobox-core';

const fontIconStyle: React.CSSProperties = {
    alignSelf: 'center',
};

const hiddenStyle: React.CSSProperties = {
    display: 'none',
    visibility: 'hidden',
};

export function defaultOnRenderIcon(props: IGroupedComboBoxButtonIconProps): OnRenderIconResult {
    const iconName = props.item.icon?.source;
    if (!iconName) {
        return [null];
    }

    const content = <FontIcon iconName={iconName} style={fontIconStyle} />;
    return [content];
}

export function defaultOnRenderLabel(props: IGroupedComboBoxButtonLabelProps): React.ReactNode {
    const { item, labelClassName, indicatorClassName, indicatorIconName } = props;
    const { showIndicator, displayText, text } = item;
    const label = displayText ?? text;
    return (
        <>
            {showIndicator && indicatorIconName && (
                <FontIcon className={indicatorClassName} iconName={indicatorIconName} />
            )}
            <span className={labelClassName}>{label}</span>
        </>
    );
}

export function renderSubmenuInternalList(
    refreshContainingMenu: RefreshSubmenuCallback,
    props?: IContextualMenuListProps,
    defaultRender?: (props?: IContextualMenuListProps) => JSX.Element | null
): JSX.Element | null {
    return (
        <SubmenuContext.Provider value={{ refreshContainingMenu }}>
            {defaultRender?.(props)}
        </SubmenuContext.Provider>
    );
}

/**
 * Render a hidden element which is only used to provide aria description for another element (via the aria-describedBy attribute)
 */
export function renderHiddenElement(id: string, content: string): React.ReactElement {
    return (
        <span id={id} aria-hidden={true} style={hiddenStyle}>
            {content}
        </span>
    );
}
